import React from 'react'
import {
    AiFillInstagram,
    AiFillFacebook,
    AiFillGithub,
    AiFillLinkedin
  } from "react-icons/ai";
import {SiFiverr} from "react-icons/si"
import Msg2 from './Msg2';
import profilepic from "../images/profilepic.png"


const Footer = () => {
  return (
    <div style={{
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "#6e07f3",
        width: "100vw",
        padding: "150px 0px 50px"
    }}>
      <Msg2/>
      <div style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transform: "translateY(-100px)"
      }}>
      <h3>E-Mail : lexypaul14@gmail.com</h3>
      {/* <h3>Phone : +92-343-898-1286</h3> */}
        <img style={{
          margin: "20px",
          borderRadius: "100%"
        }} width={"150px"} alt={"Waleed-Nasir"} src={profilepic} />
        <h3 style={{
          margin: "0px 0px",
          fontWeight: "500",
          width: "350px"
        }}>Living, learning, & leveling up one day at a time.</h3>
        <div className="icons" style={{
            maxWidth: "200px",
            textAlign: "center",
            display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }} >
        {/* <a href="https://www.instagram.com/codingbywaleed/" target={"_blank"}>
          <AiFillInstagram />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=100086241325458"
          target={"_blank"}
        >
          <AiFillFacebook /> 
      </a> */}
        <a href="https://github.com/lexypaul13" target={"_blank"}>
          <AiFillGithub />
        </a>
        <a href="https://www.linkedin.com/in/lexypaul/" target={"_blank"}>
          <AiFillLinkedin />
        </a>
        {/* <a style={{
          transform: "translateY(-5px)"
        }} href="https://www.fiverr.com/waleednasir24" target={"_blank"}>
          <img alt='fiverr-logo' width={"50px"} src="https://companieslogo.com/img/orig/FVRR_BIG.D-b3412798.png?t=1633676851"/>
        </a> */}
      </div>
      {/* <p className='caption'>Made By Waleed Nasir</p> */}
      </div>
    </div>
  )
}

export default Footer